
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const BarCode = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-barcode' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(BarCode);

